import React from 'react';
import { useForm } from 'react-hook-form';

// reactstrap components
import { Card, CardBody, Form, Row, Col, Input, Button, FormGroup, InputGroupAddon, InputGroupText, InputGroup } from "reactstrap";

// services
import { showMessage } from "services/message.js";
import { api_PUT } from "services/api_service.js";

//Context
import { useAuth } from '../../context/auth';

export default function TrocarSenha({ history }) {
    const {session, setLoading} = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const onSubmit = (data) => {
        if (data.novaSenha.length < 5) {
            showMessage("Atenção", "Informe uma senha com pelo menos 5 dígitos!", 'warning', null);
            return;
        }

        if (data.novaSenha != data.confirmarSenha) {
            showMessage("Atenção", "A confirmação da senha não confere com a nova senha!", 'warning', null);
            return;
        }

        let jsonSubmit = {
            usuario_Id: session.usuario_Id,
            password: data.novaSenha,
            password_antiga: data.senha
        }

        setLoading(true);
        api_PUT(`usuario/alterarsenha/`, jsonSubmit)
            .then(result => {
                showMessage("Aviso", "Senha alterada com sucesso!", 'success', null);
                setValue("senha", "");
                setValue("novaSenha", "");
                setValue("confirmarSenha", "");
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card className="card-user">
                            <CardBody style={{ minHeight: "auto" }}>
                                <Form style={{ maxWidth: "95%", margin: "0 auto" }} onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <label>Senha Antiga</label>
                                                <br />
                                                <InputGroup className="input-group-alternative">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fas fa-key" />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="senha" innerRef={register({ required: true })} />
                                                </InputGroup>
                                                {errors.senha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label>Nova Senha</label>
                                                <br />
                                                <InputGroup className="input-group-alternative">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fas fa-key" />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="novaSenha" innerRef={register({ required: true })} />
                                                </InputGroup>
                                                {errors.novaSenha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label>Confirmar Senha</label>
                                                <br />
                                                <InputGroup className="input-group-alternative">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fas fa-key" />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="confirmarSenha" innerRef={register({ required: true })} />
                                                </InputGroup>
                                                {errors.confirmarSenha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="text-center">
                                        <Col md="12">
                                            <Button color="success" className="btn-mobile" type="submit"><i className="fas fa-save"></i> Salvar</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}